import { createInfiniteQuery } from '../api/infiniteQuery'
import { createQuery } from '../api/query'
import {
    APIDocumentType,
    APIRecentFiles,
    DocumentInterface,
    DocumentVersion,
    DocumentVersionSummary,
    ExportStatsResponse,
    GlobalSearchResponse,
} from './types'

export const keyDocuments = (arg: string) => [`/documents`, arg]
export const useQueryDocuments = createQuery<APIDocumentType>({
    key: keyDocuments,
    url: '/documents',
})

export const keyFavoriteDocuments = (arg: string) => [`/favorite-documents`, arg]
export const useQueryFavoriteDocuments = createQuery<APIDocumentType>({
    key: keyFavoriteDocuments,
    url: '/documents',
})

export const keyDocument = (arg: string) => [`/document`, arg]
export const useQueryDocument = createQuery<DocumentInterface>({
    key: keyDocument,
    url: '/document',
})

export const keyRecentDocuments = (arg: string) => [`/recent-documents`, arg]
export const useQueryRecentDocuments = createQuery<APIRecentFiles>({
    key: keyRecentDocuments,
    url: '/recent-documents',
})

export const keySharedDocuments = (arg: string) => [`/shared-documents`, arg]
export const useQuerySharedDocuments = createQuery<APIDocumentType>({
    key: keySharedDocuments,
    url: '/shared-documents',
})

export const keyDeletedDocuments = (arg: string) => [`/deleted-documents`, arg]
export const useQueryDeletedDocuments = createQuery<APIDocumentType>({
    key: keyDeletedDocuments,
    url: '/deleted-documents',
})

const keyBrandFilesFolders = () => [`/brand-files/folders`]
export const useQueryBrandFilesFolders = createQuery<DocumentInterface[]>({
    key: keyBrandFilesFolders,
    url: '/brand-files/folders',
})

const keyDocumentAccessRequests = (arg: string) => [`/document/access-requests`, arg]
export const useQueryDocumentAccessRequests = createQuery<any[]>({
    key: keyDocumentAccessRequests,
    url: '/document/access-requests',
})

const keyDocumentStats = (arg: string) => [`/stats`, arg]
export const useQueryDocumentStats = createQuery<ExportStatsResponse>({
    key: keyDocumentStats,
    url: '/stats',
})

const keyGlobalSearch = (arg: string) => [`/global-search`, arg]
export const useQueryGlobalSearch = createQuery<GlobalSearchResponse>({
    key: keyGlobalSearch,
    url: '/global-search',
    options: {
        keepPreviousData: true,
    },
})

export const keyDocumentVersions = (arg: string) => [`/document-versions`, arg]
export const useQueryDocumentVersions = createQuery<DocumentVersionSummary[]>({
    key: keyDocumentVersions,
    url: '/document-versions',
})

export const keyDocumentVersion = (arg: string) => [`/document-version`, arg]
export const useQueryDocumentVersion = createQuery<DocumentVersion>({
    key: keyDocumentVersion,
    url: '/document-version',
})

// Infinite scroll queries for Finder sections
export const useInfiniteDocuments = createInfiniteQuery<DocumentInterface>({
    key: keyDocuments,
    url: '/documents',
})

export const useInfiniteSharedDocuments = createInfiniteQuery<DocumentInterface>({
    key: keySharedDocuments,
    url: '/shared-documents',
})

export const useInfiniteFavoriteDocuments = createInfiniteQuery<DocumentInterface>({
    key: keyFavoriteDocuments,
    url: '/documents',
})

export const useInfiniteDeletedDocuments = createInfiniteQuery<DocumentInterface>({
    key: keyDeletedDocuments,
    url: '/deleted-documents',
})

export const useInfiniteRecentDocuments = createInfiniteQuery<DocumentInterface>({
    key: keyRecentDocuments,
    url: '/recent-documents',
})
